import React, { Component } from 'react';

class CreditProposal extends Component {
    render() {
        return (
            <p>Aquí se renderiza la propuesta del crédito</p>
        );
    }
}

export default CreditProposal;